import { render, staticRenderFns } from "./SimpleCampaigns.vue?vue&type=template&id=e4ce127a"
import script from "./SimpleCampaigns.vue?vue&type=script&lang=js"
export * from "./SimpleCampaigns.vue?vue&type=script&lang=js"
import style0 from "./SimpleCampaigns.vue?vue&type=style&index=0&id=e4ce127a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports